import React from 'react';
import { TextField as TextFieldType } from '../../types/optionTypes';

interface TextFieldProps {
    field: TextFieldType;
    value: any;
    onChange: (value: any) => void;
}

export const TextField: React.FC<TextFieldProps> = ({ field, value, onChange }) => {
    const inputType = field.subtype === 'number' || field.type === 'number' ? 'number' : 'text';

    return (
        <div className="w-full">
            {field.label && (
                <label className="block text-sm font-medium text-gray-800 mb-2">
                    {field.label}
                    {field.required && <span className="text-red-500 ml-1">*</span>}
                </label>
            )}

            <input
                type={inputType}
                value={value || ''}
                onChange={(e) => onChange(e.target.value)}
                placeholder={field.placeholder}
                required={field.required}
                min={field.min}
                max={field.max}
                className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md shadow-sm bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors hover:border-gray-400"
            />

            {field.description && (
                <div className="mt-1.5 text-xs text-gray-600 leading-relaxed" dangerouslySetInnerHTML={{ __html: field.description }} />
            )}
            {field.errorMessage && (
                <p className="text-xs text-red-500 mt-1">{field.errorMessage}</p>
            )}
        </div>
    );
};
